import { CardsService, type PostCardAdminRequest, type PutCardAdminRequest } from '@/backend/market'
import { CardRepository } from '../../domain/repositories/CardRepository'
import { CardModel } from '../models/CardModel'
import { CardMiniModel } from '../models/CardMiniModel'
import type { CardMiniEntity } from '../../domain/entities/CardMiniEntity'
import type { CardEntity } from '../../domain/entities/CardEntity'
import type { CreateUpdateCardEntity } from '../../domain/entities/CreateUpdateCardEntity'
import { CreateUpdateCardModel } from '../models/CreateUpdateCardModel'
import type { CardFilterEntity } from '../../domain/entities/CardFilterEntity'
import { CardFilterModel } from '../models/CardFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'

export class CardRepositoryImpl implements CardRepository {
  async getCards(
    filterData: CardFilterEntity
  ): Promise<PaginateEntity<CardMiniEntity[]> | { error: true }> {
    const cardFilterModel = new CardFilterModel(filterData)
    try {
      const response = await CardsService.getCardsAdmin(cardFilterModel)
      const cards = response.items?.map((card) => new CardMiniModel(card))
      const cardResponse = new PaginateEntity<CardMiniModel[]>(response, cards)

      return cardResponse
    } catch {
      return { error: true }
    }
  }
  async getCard(id: number): Promise<CardEntity | { error: true }> {
    try {
      const response = await CardsService.getCardAdmin({ id })
      const cardModel = new CardModel(response)
      return cardModel
    } catch {
      return { error: true }
    }
  }
  async createCard(cardData: CreateUpdateCardEntity): Promise<{ success: true } | { error: true }> {
    const cardDataDto = new CreateUpdateCardModel(cardData)
    try {
      await CardsService.postCardAdmin({
        requestBody: cardDataDto as unknown as PostCardAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateCard(
    id: number,
    cardData: CreateUpdateCardEntity
  ): Promise<{ success: true } | { error: true }> {
    const cardDataDto = new CreateUpdateCardModel(cardData)
    try {
      await CardsService.updateCardAdmin({
        id,
        requestBody: cardDataDto as unknown as PutCardAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteCard(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CardsService.deleteCardAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async orderCard(id: number, newOrder: number): Promise<{ success: true } | { error: true }> {
    try {
      await CardsService.updateCardOrderAdmin({
        id,
        requestBody: {
          requestedOrder: newOrder
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
